import { useEffect } from "react";
import { motion } from "framer-motion";
import { FandomQuiz } from "@/components/FandomQuiz";
import { CharacterGallery } from "@/components/CharacterGallery";
import { RevealLines } from "@/components/Reveal";
import { DR, DR_PAIRS } from "@/components/danganronpaData";
import { PairSets } from "@/components/PairSets";
import { DR_CHARM } from "@/components/charms";

const ACCENT = {
  text: "text-pink-300", soft: "text-pink-200", border: "border-pink-200/25", bar: "bg-pink-400",
  hover: "hover:border-pink-300 hover:bg-pink-900/30", glow: "rgba(236,72,153,0.22)",
  panel: "bg-[#1c0710]/85", answer: "border-pink-200/25 bg-[#0b0306]/60",
};

export default function DanganronpaPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main className="relative pt-28" data-testid="danganronpa-page">
      <div className="fixed inset-0 -z-10 bg-[#0b0507]" data-testid="danganronpa-bg" aria-hidden="true"
        style={{ backgroundImage: "radial-gradient(60% 50% at 85% 10%, rgba(236,72,153,0.28), transparent 70%), radial-gradient(50% 45% at 5% 90%, rgba(190,18,60,0.25), transparent 70%), linear-gradient(115deg, transparent 49.8%, rgba(255,255,255,0.03) 50%, transparent 50.2%)" }} />
      <section className="relative max-w-[1400px] mx-auto px-5 md:px-10 pt-10 pb-6 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-pink-200">Danganronpa · fan corner</p>
          <h1 className="mt-6 font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.92] tracking-tight" data-testid="danganronpa-title">
            <RevealLines lines={[<>Hope, despair</>, <em className="text-pink-300">and beads.</em>]} />
          </h1>
          <p className="mt-6 max-w-lg text-purple-50/90 leading-relaxed">
            Find your Ultimate match, then wear their colors. Every student's bracelet can be made by hand just for you.
          </p>
        </div>
        <motion.div initial={{ opacity: 0, y: 40, rotate: 0 }} animate={{ opacity: 1, y: 0, rotate: -3 }}
          transition={{ duration: 1.1, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-5 relative mx-auto w-full max-w-[340px] lg:max-w-[400px]">
          <div className="absolute -inset-6 rounded-[32px] bg-pink-500/20 blur-3xl" aria-hidden="true" />
          <img src="/img/danganronpa-cover.jpg" alt="Danganronpa: The Animation volume 1 cover with Monokuma and the students"
            data-testid="danganronpa-cover"
            className="relative w-full aspect-[724/1024] object-cover rounded-[20px] border border-pink-200/30 shadow-[0_30px_80px_-20px_rgba(236,72,153,0.5)]" />
        </motion.div>
      </section>
      <FandomQuiz id="dr-quiz" prefix="dr" label="Class trial · personality" lines={["Which Ultimate", "are you?"]}
        intro="Answer seven questions to find your Danganronpa student." quiz={DR} accent={ACCENT} charm={DR_CHARM}>
        <CharacterGallery characters={DR.CHARACTERS} prefix="dr-gallery" accentText="text-pink-300" accentSoft="text-pink-200/90"
          blurb="Every student from the quiz, in their own colors. Pick one and make it yours for $10."
          cardClass="border-pink-200/20 bg-[#1c0710]/85 hover:border-pink-200/50" charm={DR_CHARM} />
        <PairSets pairs={DR_PAIRS} characters={DR.CHARACTERS} fandom="Danganronpa" prefix="dr-pairs" accent={ACCENT} charm={DR_CHARM} />
      </FandomQuiz>
    </main>
  );
}
